module.exports = __webpack_public_path__ + "media/images/icons/outlined/qq-fa39ab63e5a2bd1298f51d8d5baef2ce.svg";